// @needs-native-review — best-effort translation
import type { ChromeTranslations } from '../types';

export const de: ChromeTranslations = {
  'nav.nextPage': 'nächste Seite →',
  'nav.previousPage': '← vorherige Seite',
  'nav.continueToLevel': 'weiter zum Level →',
  'nav.backToMenu': 'zurück zum Menü →',
  'howto.page': 'Seite {n} von {total}',
  'options.title': 'Optionen',
  'ui.language': 'Sprache',
};
